import { PRODUCTS_URL, UPLOAD_URL } from '../constants';
import { apiSlice } from './apiSlice';

export const productsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProducts: builder.query({
      query: ({ keyword, pageNumber, sortBy }) => ({
        url: PRODUCTS_URL,
        params: {
          keyword,
          pageNumber,
          sortBy: sortBy || 'position_asc',
        },
      }),
      providesTags: ['Products'],
      keepUnusedDataFor: 5,
    }),
    // ✅ AJOUTEZ CETTE REQUÊTE POUR LES CATÉGORIES
    getProductsByCategory: builder.query({
      query: ({ category, type = null }) => {
        const params = {};
        if (type !== null) {
          params.type = type;
        }

        return {
          url: `${PRODUCTS_URL}/category/${category}`,
          params,
        };
      },
      providesTags: ['Products'],
      keepUnusedDataFor: 5,
    }),
    getProductDetails: builder.query({
      query: (productId) => ({
        url: `${PRODUCTS_URL}/${productId}`,
      }),
      keepUnusedDataFor: 5,
    }),

    createProduct: builder.mutation({
      query: () => ({
        url: `${PRODUCTS_URL}`,
        method: 'POST',
      }),
      invalidatesTags: ['Product'],
    }),

    // New Mutation for creating a Formateur product
    createProductFormateur: builder.mutation({
      query: () => ({
        url: `${PRODUCTS_URL}/formateur`,
        method: 'POST',
      }),
      invalidatesTags: ['Product'],
    }),

    updateProduct: builder.mutation({
      query: (data) => ({
        url: `${PRODUCTS_URL}/${data.productId}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Products'],
    }),

    uploadProductImage: builder.mutation({
      query: (data) => ({
        url: `${UPLOAD_URL}`,
        method: 'POST',
        body: data,
      }),
    }),

    deleteProduct: builder.mutation({
      query: (productId) => ({
        url: `${PRODUCTS_URL}/${productId}`,
        method: 'DELETE',
      }),
      providesTags: ['Product'],
    }),

    createProductWithPosition: builder.mutation({
      query: (productData) => ({
        url: PRODUCTS_URL,
        method: 'POST',
        body: productData,
      }),
      invalidatesTags: ['Product'],
    }),

    updateProductWithPosition: builder.mutation({
      query: ({ productId, ...productData }) => ({
        url: `${PRODUCTS_URL}/${productId}`,
        method: 'PUT',
        body: productData,
      }),
      invalidatesTags: ['Product'],
    }),

    getProductPosition: builder.query({
      query: (productId) => `${PRODUCTS_URL}/${productId}/position`,
    }),

    sortProducts: builder.query({
      query: (sortBy) => ({
        url: `${PRODUCTS_URL}/sort/${sortBy}`,
      }),
    }),
  }),
});

export const {
  useGetProductsQuery,
  useGetProductsByCategoryQuery,
  useGetProductDetailsQuery,
  useCreateProductMutation,
  useCreateProductFormateurMutation,
  useUpdateProductMutation,
  useUploadProductImageMutation,
  useDeleteProductMutation,
  useUpdateProductWithPositionMutation,
  useCreateProductWithPositionMutation,
  useGetProductPositionQuery,
  useSortProductsQuery,
} = productsApiSlice;
